import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { API } from "@/lib/api";

const SiteContext = createContext(null);

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function resolveImg(url) {
  if (!url) return "";
  return url.startsWith("http") ? url : `${BACKEND_URL}${url}`;
}

export function SiteProvider({ children }) {
  const [content, setContent] = useState({});
  const [images, setImages] = useState({});
  const [settings, setSettings] = useState({});
  const [snippets, setSnippets] = useState({});
  const [loaded, setLoaded] = useState(false);

  const load = useCallback(async () => {
    try {
      const [c, i, s, sn] = await Promise.all([
        axios.get(`${API}/content`),
        axios.get(`${API}/images`),
        axios.get(`${API}/settings`),
        axios.get(`${API}/snippets`),
      ]);
      setContent(c.data || {});
      setImages(i.data || {});
      setSettings(s.data || {});
      setSnippets(sn.data || {});
    } catch (e) {
      console.error("Failed to load site content:", e);
      // fall through with defaults
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const page = useCallback(
    (key) => content[key] || { hero: {}, body_html: "" },
    [content]
  );
  const img = useCallback(
    (slot, fallback = "") => resolveImg(images[slot]) || fallback,
    [images]
  );
  const snip = useCallback(
    (key, fallback = "") => (snippets[key] != null && snippets[key] !== "" ? snippets[key] : fallback),
    [snippets]
  );

  return (
    <SiteContext.Provider value={{ content, images, settings, snippets, loaded, page, img, snip, reload: load }}>
      {children}
    </SiteContext.Provider>
  );
}

export const useSite = () => useContext(SiteContext);
